export default __webpack_public_path__ + "static/media/lifeIns.4f4bd6cf.jpg";